
import { Component, Vue } from 'vue-property-decorator';
import { InputValidationRules } from 'vuetify';
import { User } from '@/features/auth/types';
import { emailRules, requiredRules } from '@/features/common/helpers/validationRules';
import { getFullUrlWithOrigin } from '@/features/common/helpers';

@Component
export default class SignUp extends Vue {
  private colors = {
    orange: '#ffa43c',
  };

  private firstName = '';

  private lastName = '';

  private email = '';

  private password = '';

  private isReferralCode = false;

  private referralCode = '';

  private showPass = false;

  private requiredRules = requiredRules;

  private emailRules: InputValidationRules = [
    ...this.requiredRules,
    ...emailRules,
  ]

  private getFullUrlWithOrigin = getFullUrlWithOrigin;

  get passSafety(): string {
    const strongPass = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/;
    const mediumPass = /((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,}))/;
    let passStrength = '';

    if (strongPass.test(this.password)) {
      passStrength = 'strong';
    } else if (mediumPass.test(this.password)) {
      passStrength = 'fair';
    } else {
      passStrength = 'weak';
    }

    return passStrength;
  }

  get user(): User {
    return this.$store.state.registration.user;
  }

  private submit(): void {
    const isValid = (this.$refs.form as Vue & { validate: () => boolean }).validate();

    const data = {
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      password: this.password,
      referralCode: this.referralCode,
    };

    if (isValid) {
      this.$store.commit('setUser', { ...this.user, ...data });
      this.$emit('next');
    }
  }
}
